// extracted by mini-css-extract-plugin
export default {"tooltip":"YO-z","arrow":"ZO-z"};